import { z } from 'zod'

export const UserRoleEnum = z.enum([
  'Administrator',
  'Client',
  'Manager',
  'PropertyManager',
  'ShiftManager',
  'Staff',
  'Trainer',
  'Valet',
  'ParkingStaff',
])

export type UserRole = z.infer<typeof UserRoleEnum>

export const USER_ROLE_LABEL_MAP: Record<UserRole, string> = {
  Administrator: 'Administrator',
  Client: 'Client',
  Manager: 'Manager',
  ParkingStaff: 'Parking Staff',
  PropertyManager: 'Property Manager',
  ShiftManager: 'Shift Manager',
  Staff: 'Staff',
  Trainer: 'Trainer',
  Valet: 'Valet',
}
